@if (isLoading) {
  <div [ngClass]="{'image-loading': isLoading}"
    class="d-flex align-items-center justify-content-center w-100 h-100 mb-0 alert alert-info text-center">
    <span translate>Loading image ....</span>
  </div>
}

@if (configurationIssue) {
  <div
    class="d-flex align-items-center justify-content-center w-100 h-100 mb-0 alert alert-info text-center">
    <span translate>There is a configuration issue ....</span>
  </div>
}

@if (!configurationIssue && !isLoading && !image) {
  <div
    class="d-flex align-items-center justify-content-center w-100 h-100 mb-0 alert alert-info text-center">
    <span>
      <span class="mr-1" translate>Cannot load image</span>
      <span [innerHTML]="imageName"></span>
    </span>
  </div>
}

@if (!isLoading && !configurationIssue && image) {
  <img [src]="image | imageContentSafeImageUrl"
    class="image-fill-parent" alt="">
}
